<template>
    <div class="purge-css hidden">
        <div class="adding-purge-css" />
    </div>
</template>

<script>
export default {
    name: 'PurgeCssComponent',
}
</script>

<style lang="scss">
.purge-css {
    .adding-purge-css {
        // col span
        @apply col-span-2 col-span-4 col-span-4 col-span-5 col-span-6 col-span-7 col-span-8 col-span-9 col-span-10 col-span-11 col-span-12;
    }
}
</style>
